import React, { useEffect } from 'react';
import { useAdviserDetails } from './components/hooks/AppStateHook';
import { trackSession } from './logic/functions/sessionTracking.function';
import { IdentityInfo } from './logic/domains/identityInformation.domain';

const waitAndTrackSession = (customerNumber: string, csrUserId?: string) => {
	let counter = 20;
	const countdown = setInterval(function() {
		let result = trackSession(customerNumber, csrUserId);
		counter--;
		if (counter === 0 || result) {
			clearInterval(countdown);
		}
	}, 1000);
};

export const SessionTracker: React.FC = () => {
	const adviser = (useAdviserDetails() as unknown) as IdentityInfo;

	useEffect(() => {
		waitAndTrackSession(adviser.customerNumber, adviser.csrUserId);
	}, [adviser.customerNumber]);

	return null;
};
